module.exports = __webpack_public_path__ + "static/img/qrj.92aa3a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/qrj.png
// module id = SLQK
// module chunks = 59